import { Route, Routes } from '@angular/router';
import { AuthGuard } from '@app/auth';
import { ShellComponent } from './shell.component';
import { MaintenanceInProgressGuard } from '@shared/guards/maintenanceInProgress.guard';

export class Shell {
  public static childRoutes(routes: Routes, protectedByAuthGuard: boolean = true): Route {
    return {
      path: '',
      component: ShellComponent,
      children: routes,

      // Trick with Guards: when we have several asynchronous guards, they are not executed one after the other
      //    => we can't use AuthGuard & MaintenanceInProgressGuard together as we want to prevent AuthGuard from retrieving participant data if maintenanceMode is ON.
      // So AuthGuard checks first if maintenance is activated and if we don't have AuthGuard (for friendsSurvey route for instance)
      // We add the MaintenanceInProgressGuard to still check if maintenanceMode is ON.
      canActivate: protectedByAuthGuard ? [AuthGuard] : [MaintenanceInProgressGuard],
    };
  }
}
